import { BBox2D } from '@symplicity/geocoding';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { geolocationToBBox } from '../../../helpers/geolocation.helpers';
import { useGetCountryOption } from '../../../hooks/useCountryOption';
import { LocationMap } from '../../LocationMap';
import { LocationInnerFormData } from '../location-form.models';

interface Props {
    id: string;
}

export const LocationMapWrapper = ({ id }: Props): React.ReactElement => {
    const getCountryOption = useGetCountryOption();
    const value = useWatch<LocationInnerFormData>({ name: id });

    const bbox: BBox2D[] = useMemo(() => {
        if (!value) {
            return [];
        }

        const countryOption = value.countryCode ? getCountryOption(value.countryCode) : undefined;
        const countryBBox = countryOption?.geolocation
            ? geolocationToBBox(countryOption.geolocation)
            : undefined;

        const bbox =
            value.street?.bbox ||
            value.postcode?.bbox ||
            value.city?.bbox ||
            value.region?.bbox ||
            value.convertedBbox ||
            countryBBox;

        return bbox ? [bbox] : [];
    }, [value, getCountryOption]);

    return <LocationMap bboxes={bbox} />;
};
